var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.03488 181.3504c-4.25472-29.696-29.54752-52.59776-60.42112-52.59776h-268.68224c-30.8736 0-56.16128 22.90176-60.42112 52.59776h-0.6144v6.07744c-0.03584 0.89088-0.26624 1.72544-0.26624 2.62144v50.80576H100.09088c-30.8736 0-56.16128 22.90176-60.42112 52.59776h-0.6144v6.07744c-0.03584 0.89088-0.26624 1.72544-0.26624 2.62144v155.43296c0 0.896 0.22528 1.73056 0.26624 2.62144v283.71456h5.34016v0.3584c0 0.896 0.22528 1.73056 0.26624 2.62144v6.07744h0.6144c4.25472 29.696 29.54752 52.59776 60.42112 52.59776h704.91648c30.8736 0 56.1664-22.90176 60.42112-52.59776h0.87552V181.3504h-0.87552z",
    fill: "#013327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.92448 271.0272c-4.25472-29.696-29.54752-52.59776-60.42112-52.59776h-268.68224c-30.8736 0-56.16128 22.90176-60.42112 52.59776h-0.6144v6.07744c-0.03584 0.89088-0.26624 1.72544-0.26624 2.62144v50.80576H200.98048c-30.8736 0-56.16128 22.90176-60.42112 52.59776h-0.6144v6.07744c-0.03584 0.89088-0.26624 1.72544-0.26624 2.62144v155.43296c0 0.896 0.22528 1.73056 0.26624 2.62144v283.71456h5.34016v0.3584c0 0.896 0.22528 1.73056 0.26624 2.62144v6.07744h0.6144c4.25472 29.696 29.54752 52.59776 60.42112 52.59776h704.91648c30.8736 0 56.1664-22.90176 60.42112-52.59776H972.8V271.0272h-0.87552z",
    fill: "#DCC9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.48544 429.78816h362.6752v53.71392H215.48544zM215.48544 533.4784h362.6752v53.71392H215.48544z",
    fill: "#013327"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubFold);
export default __webpack_public_path__ + "static/media/sub-fold.a639e017cf139be59056bed94b4d67a8.svg";
export { ForwardRef as ReactComponent };